/**
 * Transflo.WorkflowDefinition.HttpApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TriggerEnum = 'Default' | 'Conditional';

export const TriggerEnum = {
    Default: 'Default' as TriggerEnum,
    Conditional: 'Conditional' as TriggerEnum
};

